APP.popup = function () {
  // close modal policies and term
  $(document).on('click', '.close-popup', function () {
    $('.popup').removeClass('show');
  });

  $('#go-tnc').click(function () {
    $('.popup').removeClass('show');
    $('.popup.tnc').addClass('show');
  });
  $('.back-to-popup-campaign-detail').click(function(){
    $('.popup').removeClass('show');
    $('.popup.popup-campaign-detail').addClass('show');
  });
}
